import { default as $ } from 'jquery';

// As header use dropdown, we have to always load this feature
import 'bootstrap/js/dist/dropdown';

// As user consent use modal, we have to always load this feature
import 'bootstrap/js/dist/modal';

// As footer use tooltip, we have to always load this feature
import 'bootstrap/js/dist/tooltip';


function lazyLoadCollapse() {
    const elementsUsingThisFeature = document.querySelector('[data-toggle="collapse"]');
    if (elementsUsingThisFeature) {
        import(/* webpackChunkName: "bootstrap-collapse" */ 'bootstrap/js/dist/collapse');
    }
}

function lazyLoadTab() {
    const elementsUsingThisFeature = document.querySelector('[data-toggle="tab"], [data-toggle="pill"], [data-toggle="list"]');
    if (elementsUsingThisFeature) {
        import(/* webpackChunkName: "bootstrap-tab" */ 'bootstrap/js/dist/tab').then(function() {
            imaios.pubsub.publish('tab-loaded');
        });
    }
}

// todo : could be remove using native JS (used in search result for tab)
document.addEventListener('DOMContentLoaded', () => {
    lazyLoadCollapse();
    lazyLoadTab();
});


window.$ = $;
window.jQuery = $;
window.jquery = $;
